import {FC, useRef} from 'react';
import {useSelector} from '@xstate/react';
import {useAudioPanelToggle} from '../../hooks/useAudioPanelToggle';
import {useSetActiveAudio} from '../../hooks/useSetActiveAudio';
import {PanelItem, Panel} from '../panel';
import LanguagesIcon from './languagesIcon.svg';
import {
  useAudioPanelIsOpen,
  useAudioTrackService,
} from '../../hooks/useTrackContext';

export const AudioPanel: FC = () => {
  const service = useAudioTrackService();
  const audioTracks = useSelector(service, ({context}) => context.tracks);
  const activeAudioTrack = useSelector(
    service,
    ({context}) => context.activeTrack
  );

  const isOpen = useAudioPanelIsOpen();
  const panelRef = useRef<HTMLDivElement | null>(null);
  const onBlur = useAudioPanelToggle();
  const onSelect = useSetActiveAudio();

  return (
    <Panel
      isOpen={isOpen}
      onBlur={onBlur}
      ref={panelRef}
      title="Audio/Languages"
      icon={<LanguagesIcon />}
    >
      {audioTracks.map((track) => (
        <PanelItem
          key={track.id}
          ariaLabel={`${track.label} audio track`}
          label={track.label}
          isSelected={activeAudioTrack?.id === track.id}
          onClick={() => onSelect(track.id)}
        />
      ))}
    </Panel>
  );
};
